import React, { useEffect, useState } from 'react'
import GlobalCard from '../../../../../../components/GlobalCardComponent'
import { Box, Divider, Grid, Radio, Typography } from '@mui/material'
import CustomPopup from '../../../../../../components/customPopup/CustomPopup'
import ShowAllPaymentMethods from './ShowAllPaymentMethods'
import { getAllPaymentModes } from '../../../PurchaseTestApis'
import Loader from '../../../../../../../SAPPages/components/Loader/Loader'

export default function PaymentMethod() {
  const [openPaymentModes, setOpenPaymentModes] =useState(false)
  const [selectedPaymentMode , setselectedPaymentMode] =useState(null)
    const [paymentOptions, setPaymentOptions] = useState([]);
const [loading , setLoading] =useState(true)
  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      try {
        const data = await getAllPaymentModes();
        const filteredData = data?.data?.find(
          (data) => data?.payment_mode === "Razorpay"
        );
         const filteredDataList = data?.data?.filter(
          (data) => data?.payment_mode === "Razorpay"
        );
        setselectedPaymentMode(filteredData);
        setPaymentOptions(filteredDataList)
        setLoading(false);
      } catch (err) {
        console.error("Could not fetch modes");
        setselectedPaymentMode(null);
        setLoading(false);
      }
    };

    fetchData();
  }, []);



  const handleOpenPaymentMode =() =>{
    setOpenPaymentModes(true)
  }

    const handleClosePaymentMode =() =>{
    setOpenPaymentModes(false)
  }

  return (
   <>
   <GlobalCard>
    <Grid container >
 <Grid item xs={8}>
            <Typography
              textAlign="start"
              color="#222222"
              fontFamily="Inter"
              fontSize="18px"
              lineHeight="100%"
              letterSpacing="0px"
              fontStyle="normal"
              style={{ fontWeight: 500 }}
            >
            Payment Method
            </Typography>
          </Grid>

           {/* <Grid item xs={4}>
            <Typography
              textAlign="end"
              color="#00A5F5"
              fontFamily="Inter"
              fontSize="11px"
              lineHeight="100%"
              letterSpacing="0px"
              fontStyle="normal"
              onClick={handleOpenPaymentMode}
              style={{ fontWeight: 500 , textDecoration: "underline", cursor:"pointer"}}
            >
      Change Method
            </Typography>
          </Grid> */}
          <Grid item xs={12} mt={2}>
             <Divider sx={{ borderColor:" #DDDDDD" }} />
          </Grid>

{loading ? (
 <Grid item xs={12}>
            <Loader text="Loading Payment Methods..." height="20vh" />
          </Grid>
) :(

          <Grid item xs={12} sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            
              <Radio
                  checked
                  sx={{
                    color: "#572575",
                    "&.Mui-checked": { color: "#572575" },
                  }}
                />
              <Typography
                    fontFamily="Inter"
                    fontWeight={700}
                    fontSize="16px"
                    color="#572575"
                  >
                    {selectedPaymentMode?.payment_mode}
                  </Typography>
             
                
              

            
          </Grid>
           )}
    </Grid>
   </GlobalCard>


     <CustomPopup
        handleClose={handleClosePaymentMode}
        component={
          <ShowAllPaymentMethods
            handleClose={handleClosePaymentMode}
            setselectedPaymentMode={setselectedPaymentMode}
            setPaymentOptions={setPaymentOptions}
            paymentOptions={paymentOptions}
          />
        }
        open={openPaymentModes}
        subtitle=""
        maxWidth="sm"
      hideCrossButton={true}
      />

   </>
  )
}
